<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">Акции</div>

      <div class="panel-body">

        <div class="loader" v-show="!loaded"></div>

        <div class="row" v-show="loaded">
          <div class="col-md-8">

          </div>
          <div class="col-md-4">
            <button class="btn btn-default pull-right" type="submit" @click="add()">
              Добавить
            </button>
          </div>
        </div>

        <table class="table" v-show="loaded">
          <thead>
          <tr>
            <th>#</th>
            <th>Фото</th>
            <th>Акция</th>
            <th>Описание</th>
            <th>Сортировка</th>
            <th>Показ на сайте</th>
            <th class="text-right">Действие</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in list">
            <td>{{item.id}}</td>
            <td><img :src="url+item.image" width="60" alt=""></td>
            <td>{{item.name}}</td>
            <td>{{item.description}}</td>
            <td>{{item.sort}}</td>
            <td>{{item.visible ? 'Да' : 'Нет'}}</td>
            <td>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="edit(item)"><span class="glyphicon glyphicon-edit"></span></button>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="del(item.id, item.name)"><span class="glyphicon glyphicon-trash"></span></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal v-model="modalShow" size="lg" title="Акция" @hide="modalHide()" @before-close="beforeClose">
      <!--error-->
      <div class="alert alert-danger fade in" v-show="modalError">
        <p>{{modalError}}</p>
      </div>

      <!--form-->
      <form name="modal-form" id="modal-form">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="name" class="control-label">Title:</label>
              <input class="form-control" id="name" v-model="modalData.seo_title">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="slug" class="control-label">Description:</label>
              <input class="form-control" id="slug" v-model="modalData.seo_description">
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="image">Изображение</label>
          <div class="image-wrap" :style="{backgroundImage: 'url('+url+modalData.image+')'}">
            <span v-show="!modalData.image">Изображение отсутствует</span>
          </div>
          <input type="file" id="image">
          <p class="help-block">Выберите изображение для загрузки (570x376 jpg,png)</p>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="name" class="control-label">Название акции:</label>
              <input class="form-control" id="name" v-model="modalData.name">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="slug" class="control-label">URL:</label>
              <input class="form-control" id="slug" v-model="modalData.slug">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="desc1" class="control-label">Описание (строка 1):</label>
              <textarea class="form-control" rows="3" id="desc1" v-model="modalData.desc1"></textarea>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="desc2" class="control-label">Описание (строка 2):</label>
              <textarea class="form-control" rows="3" id="desc2" v-model="modalData.desc2"></textarea>
            </div>
          </div>
        </div>


        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="modalData.is_separator">
            Разделитель между 1-ой и 2-ой строкой описания
          </label>
        </div>
        <div class="form-group">
          <label for="hint" class="control-label">Текст под фото:</label>
          <input class="form-control" id="hint" v-model="modalData.hint">
        </div>
        <div class="form-group">
          <label for="sort" class="control-label">Сортировка:</label>
          <input class="form-control" id="sort" v-model="modalData.sort">
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="modalData.is_alert">
            Добавить слово "Внимание!"
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="modalData.visible">
            Включить показ на сайте
          </label>
        </div>
        <div class="form-group">
          <label for="content" class="control-label">Содержание (HTML):</label>
          <textarea class="form-control" rows="20" id="content" v-model="modalData.content"></textarea>
        </div>
      </form>

      <!-- footer -->
      <div slot="footer">
        <btn type="primary" class="pull-left" @click="store()">Сохранить</btn>
        <btn type="default" class="pull-left" @click="close()">Отмена</btn>
      </div>
    </modal>
  </div>
</template>

<script>
  import {api} from './http'
  var config = require('./config')

  export default {
    mounted () {
    },
    data () {
      return {
        url: config.appUrl,
        modalShow: false,
        modalData: {},
        modalError: '',
        categories: [],
        loaded: false,
        list: []
      }
    },
    beforeCreate () {
      this.loaded = false
      api.post('promotions/list').then(response => {
        this.loaded = true
        this.list = response.data.promotions
      })
    },
    methods: {
      beforeClose () {
      },
      refreshList () {
        this.loaded = false
        api.post('promotions/list').then(response => {
          this.loaded = true
          this.list = response.data.promotions
        })
      },
      add () {
        this.modalShow = true
      },
      edit (item) {
        var copyItem = {}
        Object.assign(copyItem, item)
        this.modalShow = true
        this.modalData = copyItem
      },
      close () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalClose () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalHide () {
        this.modalClose()
      },
      resetForm () {
        var form = document.querySelector('#modal-form')
        form.reset()
      },
      store () {
        var formData = new FormData()
        for (let key in this.modalData) {
          if (Array.isArray(this.modalData[key])) {
            for (let i in this.modalData[key]) {
              formData.append(key + '[]', this.modalData[key][i])
            }
          } else {
            let val = this.modalData[key] || ''
            formData.append(key, val)
          }
        }

        if (document.querySelector('#image').files.length) {
          var file = document.querySelector('#image').files[0]
          formData.append('image', file)
        }

        api.post('promotions/store', formData).then(response => {
          if (response.data.success) {
            this.modalClose()
            this.refreshList()
          } else {
            this.modalError = response.data.message
          }
        })
      },
      del (id, name) {
        if (!confirm('Удалить акцию "' + name + '"')) {
          return
        }

        var formData = new FormData()
        formData.append('id', id)

        api.post('promotions/delete', formData)
          .then(res => { this.refreshList() })
      },
      resetModal () {
        this.modalData = {}
      }
    }
  }
</script>

<style>
  .image-wrap {
    width: 370px;
    height: 248px;
    background-size: cover;
    border: 1px solid silver;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slider-text {
    width: 450px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminPromotions.vue